import { useHeroData } from '../hooks/useHeroData';
import { HeroCarousel } from './HeroCarousel';
import { jsx as _jsx } from "react/jsx-runtime";
export function Hero() {
  const {
    heroItems,
    loading,
    error
  } = useHeroData();
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return /*#__PURE__*/_jsx(HeroCarousel, {
    heroItems: heroItems
  });
}